import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-469a5368")

_pushScopeId("data-v-469a5368")
const _hoisted_1 = {
  key: 0,
  class: "bookingControl"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.showControlBlock)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.showbntContol[_ctx.controlbtn.BTN_CANSEL])
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "bookingControl__btn redBtn",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.cancelBoking()))
            }, " Отмена "))
          : _createCommentVNode("", true),
        (_ctx.showbntContol[_ctx.controlbtn.BTN_BOOKING])
          ? (_openBlock(), _createBlock("button", {
              key: 1,
              type: "button",
              class: "bookingControl__btn orangeBtn",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.setBoking(...args)))
            }, " Бронировать "))
          : _createCommentVNode("", true),
        (_ctx.showbntContol[_ctx.controlbtn.BTN_TIKENTING])
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              type: "button",
              class: "bookingControl__btn orangeBtn",
              onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.ticketingBoking(...args)))
            }, " Выписать билет "))
          : _createCommentVNode("", true),
        (_ctx.showbntContol[_ctx.controlbtn.BTN_REFAUND])
          ? (_openBlock(), _createBlock("button", {
              key: 3,
              type: "button",
              class: "bookingControl__btn orangeBtn",
              onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.rejectBoking(...args)))
            }, " Возврат билета "))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})